// extracted by mini-css-extract-plugin
module.exports = {"newsCard":"style_newsCard__didDk","copy":"style_copy__JVgG9","top":"style_top__UtlGM"};